import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../DataTable/DataTable';
import { EApiType, EDataTableType, EModuleType } from '../../data/Constants';
import { getArchivedConfiguration } from '../../store/states/DataMaintenanceSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const ArchivedConfiguration = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ArchivedConfigurationKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.archivedConfiguration')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.ArchivedConfiguration}
        getDataList={getArchivedConfiguration}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
